<div id="date" (click)="openCalendar()" [ngStyle]="{'min-height': height ? (height + 'px') : '', 'background': whiteBackground ? 'white' : ''}">
    <img class="calendar-icon" src="../../../../../../assets/icons/calendar.svg"/>
    <span [ngStyle]="{'color': date ? '#0568af' : '#00000050'}">
        {{date ? 
        ((getWeekEndDate() && showEndDate) ? ((date | date: 'MM-dd-yyyy') + ' - ' + (getWeekEndDate() | date: 'MM-dd-yyyy')) : (date | date: 'MM-dd-yyyy')) 
        : placeholder}}
    </span>
</div>